import { all, takeEvery, put, fork, call, takeLeading } from 'redux-saga/effects';
import actions from './actions';
import {
  getGeneralInfosService, getClinicsWithMostPatientsService, getUsersWithMostPatientsService,
  getBackgroundLogsService, getGeneralErrorLogsService, getDatabasesService,
  getBackupsService, getLogsDataService, getSingleClinicDetailsService,
  createNewUserService, getUserDetailsService, changeUserPasswordService, changeUserStatusService,
  getUserBackgroundLogsService, getUserAuditLogsService, getClinicNamesService,
  getUserNamesService, getClinicBackgroundLogsService, getDailyStatisticsForDayService,getDailyStatisticsForPeriodService, getWeeklyStatisticsService, getAvailablePermissionsService,
  updateUserService,
  getUserPermissionsService
} from './systemInfosServices';
import { DvNotification } from "../../components/utility/dvGeneralUtilities";

function* getGeneralInfos(action) {
  const response = yield call(getGeneralInfosService);

  let payload = [];

  if (response.status === 1) {
    payload = response.results;
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "homePage.generalInfos.getData",
      messageId: "error.systemInfo.generalInfos.failToGetData"
    });
  }

  yield put({
    type: actions.GET_GENERAL_INFOS_RESPONSE,
    payload: payload
  });
}

function* getClinicsWithMostPatients(action) {
  const response = yield call(getClinicsWithMostPatientsService);

  let payload = [];

  if (response.status === 1) {
    payload = response.results || [];
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "homePage.clinicsWithMostPatients.chartTitle",
      messageId: "error.general.failToGetData"
    });
  }

  yield put({
    type: actions.GET_CLINICS_WITH_MOST_PATIENTS_RESPONSE,
    payload: payload
  });
}

function* getUsersWithMostPatients(action) {
  const response = yield call(getUsersWithMostPatientsService);

  let payload = [];

  if (response.status === 1) {
    payload = response.results || [];
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "homePage.usersWithMostPatients.chartTitle",
      messageId: "error.general.failToGetData"
    });
  }

  yield put({
    type: actions.GET_USERS_WITH_MOST_PATIENTS_RESPONSE,
    payload: payload
  });
}

function* getBackgroundLogs(action) {
  const response = yield call(getBackgroundLogsService);

  let payload = [];

  if (response.status === 1) {
    payload = response.results?.logs || [];
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "homePage.backgrounLogs.title",
      messageId: "error.general.failToGetData"
    });
  }

  yield put({
    type: actions.GET_BACKGROUND_LOGS_RESPONSE,
    payload: payload
  });
}

function* getGeneralErrorLogs(action) {
  const response = yield call(getGeneralErrorLogsService);

  let payload = [];

  if (response.status === 1) {
    payload = response.results || [];
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "homePage.generalLogs.title",
      messageId: "error.general.failToGetData"
    });
  }

  yield put({
    type: actions.GET_GENERAL_LOGS_RESPONSE,
    payload: payload
  });
}

function* getDatabases(action) {
  const response = yield call(getDatabasesService);

  let payload = {};

  if (response.status === 1) {
    payload = response.results || [];
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "databases.title",
      messageId: "error.general.failToGetData"
    });
  }

  yield put({
    type: actions.GET_DATABASES_RESPONSE,
    payload: payload
  });
}

function* getBackups(action) {
  const response = yield call(getBackupsService);

  let payload = {};

  if (response.status === 1) {
    payload = response.results || [];

  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "backups.title",
      messageId: "error.general.failToGetData"
    });
  }

  yield put({
    type: actions.GET_BACKUPS_RESPONSE,
    payload: payload
  });
}

function* getLogs(action) {
  const { filters } = action;
  const response = yield call(getLogsDataService, filters);

  let payload = {
    numberOfLogs: 0,
    logs: []
  };

  if (response.status === 1) {
    payload = response.results || payload;
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "homePage.generalLogs.title",
      messageId: "error.general.failToGetData"
    });
  }

  yield put({
    type: actions.GET_LOGS_RESPONSE,
    payload: payload
  });
}

function* getClinicDetails(action) {
  const { clinicId } = action;
  let payload = {};

  const response = yield call(getSingleClinicDetailsService, clinicId);

  if (response.status === 1) {
    payload = response.results;

  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "clinicsPage.clinicDetails.title",
      messageId: "error.general.failToGetData"
    });
  }

  yield put({
    type: actions.GET_CLINIC_DETAILS_RESPONSE,
    payload: payload
  });
}

function* createNewUser(action) {
  const { values, clinicId } = action;

  const response = yield call(createNewUserService, values);

  if (response.status === 1) {
    yield all([
      put({ type: actions.GET_CLINIC_DETAILS_REQUEST, clinicId, filters: {} })
    ]);
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "clinicsPage.createNewClinic",
      messageId: !response.errors || !response.errors[0] ? "error.createNewUser" : undefined,
      messageString: response.errors && response.errors[0] ? response.errors[0] : undefined
    });
  }

  yield all([
    put({ type: actions.CREATE_NEW_USER_RESPONSE })
  ]);
}

function* updateUser(action) {
  const { values, clinicId, userId } = action;

  const response = yield call(updateUserService, userId, values);

  if (response.status === 1) {
    yield all([
      put({ type: actions.GET_CLINIC_DETAILS_REQUEST, clinicId, userId, filters: {} }),
      put({ type: actions.UPDATE_USER_RESPONSE, payload: response.results }),
      put({ type: actions.GET_USER_DETAILS_REQUEST, userId }),
      put({ type: actions.GET_USER_PERMISSIONS_REQUEST, userId }),
    ]);
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "clinicsPage.updateUser",
      messageId: "error.updateUser"
    });
  }
}

function* getUserDetails(action) {
  const { userId } = action;
  let payload = [];

  const response = yield call(getUserDetailsService, userId);

  if (response.status === 1) {
    payload = response.results || [];
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "userDetails.title",
      messageId: "error.general.failToGetData"
    });
  }

  yield put({
    type: actions.GET_USER_DETAILS_RESPONSE,
    payload: payload
  });
}

function* getUserPermissions(action) {
  const { userId } = action;
  let payload = [];

  const response = yield call(getUserPermissionsService, userId);

  if (response.status === 1) {
    payload = response.results || [];
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "userDetails.title",
      messageId: "error.general.failToGetData"
    });
  }

  yield put({
    type: actions.GET_USER_PERMISSIONS_RESPONSE,
    payload: payload
  });
}

function* changeUserPassword(action) {
  const { userId, values } = action;

  const response = yield call(changeUserPasswordService, userId, values);

  if (response.status === 1) {
    yield put({
      type: actions.CHANGE_USER_PASSWORD_RESPONSE,
    });
    DvNotification({
      type: "success",
      titleId: "userDetails.changeUserPassword",
      messageId: "userDetails.changeUserStatusSuccess"
    });
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "userDetails.changeUserPassword",
      messageId: "error.changeUserPassword"
    });
  }
}

function* changeUserStatus(action) {
  const { userId, status } = action;

  const response = yield call(changeUserStatusService, userId, status);

  if (response.status === 1) {
    yield all([
      put({ type: actions.GET_USER_DETAILS_REQUEST, userId }),
      put({ type: actions.CHANGE_USER_STATUS_RESPONSE })
    ]);

  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "userDetails.changeUserStatus",
      messageId: "error.changeUserPasswordUser"
    });
  }
}

function* getUserBackgroundJobs(action) {
  const { userId, filters } = action;
  let payload = [];

  const response = yield call(getUserBackgroundLogsService, userId, filters);

  if (response.status === 1) {
    payload = response.results || [];
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "general.backgroundJob",
      messageId: "error.general.failToGetData"
    });
  }

  yield put({
    type: actions.GET_USER_BACKGROUND_JOBS_RSPONSE,
    payload: payload
  });
}

function* getClinicBackgroundJobs(action) {
  const { clinicId, filters } = action;
  let payload = [];

  const response = yield call(getClinicBackgroundLogsService, clinicId, filters);

  if (response.status === 1) {
    payload = response.results || [];
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "general.backgroundJob",
      messageId: "error.general.failToGetData"
    });
  }

  yield put({
    type: actions.GET_CLINIC_BACKGROUND_JOBS_RSPONSE,
    payload: payload
  });
}

function* getUserAuditLogs(action) {
  const { filters } = action;
  let payload = [];

  const response = yield call(getUserAuditLogsService, filters);

  if (response.status === 1) {
    payload = response.results || [];
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "general.auditLogs",
      messageId: "error.general.failToGetData"
    });
  }

  yield put({
    type: actions.GET_USER_AUDIT_LOGS_RESPONSE,
    payload: payload
  });
}

function* getClinicNames(action) {
  let payload = [];

  const response = yield call(getClinicNamesService);

  if (response.status === 1) {
    payload = response.results || [];
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "general.auditLogs",
      messageId: "error.failToGetData"
    });
  }

  yield put({
    type: actions.GET_CLINIC_NAMES_RESPONSE,
    payload: payload
  });
}

function* getUserNames(action) {
  let payload = [];

  const response = yield call(getUserNamesService);

  if (response.status === 1) {
    payload = response.results || [];
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "general.auditLogs",
      messageId: "error.fetchUserNames"
    });
  }

  yield put({
    type: actions.GET_USER_NAMES_RESPONSE,
    payload: payload
  });
}

function* getDailyStatisticsForDay(action) {
  const { day } = action;
  let payload = [];
  const response = yield call(getDailyStatisticsForDayService, day);
  if (response.status === 1) {
    payload = response.results || [];
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "general.statistics",
      messageId: "error.fetchDailyStatistics"
    });
  }

  yield put({
    type: actions.GET_DAILY_STATISTICS_FOR_DAY_RESPONSE,
    payload: payload
  });
}

function* getDailyStatisticsForPeriod(action) {
  const { dateFrom, dateUntil } = action;
  let payload = [];
  const response = yield call(getDailyStatisticsForPeriodService, dateFrom, dateUntil);
  if (response.status === 1) {
    payload = response.results || [];
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "general.statistics",
      messageId: "error.fetchDailyStatistics"
    });
  }

  yield put({
    type: actions.GET_DAILY_STATISTICS_FOR_PERIOD_RESPONSE,
    payload: payload
  });
}

function* getWeeklyStatistics(action) {
  const { day } = action;
  let payload = [];

  const response = yield call(getWeeklyStatisticsService, day);

  if (response.status === 1) {
    payload = response.results || [];
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "general.statistics",
      messageId: "error.fetchWeeklyStatistics"
    });
  }

  yield put({
    type: actions.GET_WEEKLY_STATISTICS_RESPONSE,
    payload: payload
  });
}



function* requestGetAvaiablePermissions(action) {
  let payload = [];
  const response = yield call(getAvailablePermissionsService);

  if (response.status === 1) {
    payload = response.results || [];
  } else if (response.status === 0) {
    DvNotification({
      type: "error",
      titleId: "general.statistics",
      messageId: "error.fetchAvailablePermissions"
    });
  }

  yield put({
    type: actions.GET_AVAILABLE_PERMISSIONS_RESPONSE,
    payload: payload
  });
}

export function* watchGetGeneralInfos() {
  yield takeEvery(actions.GET_GENERAL_INFOS_REQUEST, getGeneralInfos);
}

export function* watchGetClinicsWithMostPatients() {
  yield takeEvery(actions.GET_CLINICS_WITH_MOST_PATIENTS_REQUEST, getClinicsWithMostPatients);
}

export function* watchGetUsersWithMostPatients() {
  yield takeEvery(actions.GET_USERS_WITH_MOST_PATIENTS_REQUEST, getUsersWithMostPatients);
}

export function* watchGetBackgroundLogs() {
  yield takeEvery(actions.GET_BACKGROUND_LOGS_REQUEST, getBackgroundLogs);
}

export function* watchGetGeneralLogs() {
  yield takeEvery(actions.GET_GENERAL_LOGS_REQUEST, getGeneralErrorLogs);
}

export function* watchGetDatabases() {
  yield takeEvery(actions.GET_DATABASES_REQUEST, getDatabases);
}

export function* watchGetBackups() {
  yield takeEvery(actions.GET_BACKUPS_REQUEST, getBackups);
}

export function* watchGetLogs() {
  yield takeEvery(actions.GET_LOGS_REQUEST, getLogs);
}

export function* watchGetClinicDetails() {
  yield takeEvery(actions.GET_CLINIC_DETAILS_REQUEST, getClinicDetails);
}

export function* watchCreateNewUser() {
  yield takeEvery(actions.CREATE_NEW_USER_REQUEST, createNewUser);
}

export function* watchUpdateUser() {
  yield takeEvery(actions.UPDATE_USER_REQUEST, updateUser);
}

export function* watchGetUserDetails() {
  yield takeEvery(actions.GET_USER_DETAILS_REQUEST, getUserDetails);
}

export function* watchGetUserPermissions() {
  yield takeEvery(actions.GET_USER_PERMISSIONS_REQUEST, getUserPermissions);
}

export function* watchChangeUserPassword() {
  yield takeEvery(actions.CHANGE_USER_PASSWORD_REQUEST, changeUserPassword);
}

export function* watchChangeUserStatus() {
  yield takeEvery(actions.CHANGE_USER_STATUS_REQUEST, changeUserStatus);
}

export function* watchGetUserAuditLogs() {
  yield takeEvery(actions.GET_USER_AUDIT_LOGS_REQUEST, getUserAuditLogs)
}

export function* watchGetUserBackgroundJobs() {
  yield takeEvery(actions.GET_USER_BACKGROUND_JOBS_REQUEST, getUserBackgroundJobs)
}

export function* watchGetClinicBackgroundJobs() {
  yield takeEvery(actions.GET_CLINIC_BACKGROUND_JOBS_REQUEST, getClinicBackgroundJobs)
}

export function* watchGetClinicNames() {
  yield takeEvery(actions.GET_CLINIC_NAMES_REQUEST, getClinicNames)
}

export function* watchGetUserNames() {
  yield takeEvery(actions.GET_CLINIC_NAMES_REQUEST, getUserNames)
}

export function* watchGetDailyStatisticsForDay() {
  yield takeEvery(actions.GET_DAILY_STATISTICS_FOR_DAY_REQUEST, getDailyStatisticsForDay)
}
export function* watchGetDailyStatisticsForPeriod() {
  yield takeEvery(actions.GET_DAILY_STATISTICS_FOR_PERIOD_REQUEST, getDailyStatisticsForPeriod)
}

export function* watchGetWeeklyStatistics() {
  yield takeEvery(actions.GET_WEEKLY_STATISTICS_REQUEST, getWeeklyStatistics)
}

export function* watchGetAvailablePermissionsRequest() {
  yield takeLeading(actions.GET_AVAILABLE_PERMISSIONS_REQUEST, requestGetAvaiablePermissions)
}



export default function* rootSaga() {
  yield all([
    fork(watchGetGeneralInfos),
    fork(watchGetClinicsWithMostPatients),
    fork(watchGetUsersWithMostPatients),
    fork(watchGetBackgroundLogs),
    fork(watchGetGeneralLogs),
    fork(watchGetDatabases),
    fork(watchGetBackups),
    fork(watchGetLogs),
    fork(watchGetClinicDetails),
    fork(watchCreateNewUser),
    fork(watchUpdateUser),
    fork(watchGetUserDetails),
    fork(watchGetUserPermissions),
    fork(watchChangeUserPassword),
    fork(watchChangeUserStatus),
    fork(watchGetUserBackgroundJobs),
    fork(watchGetUserAuditLogs),
    fork(watchGetClinicNames),
    fork(watchGetUserNames),
    fork(watchGetClinicBackgroundJobs),
    fork(watchGetDailyStatisticsForDay),
    fork(watchGetDailyStatisticsForPeriod),
    fork(watchGetWeeklyStatistics),
    fork(watchGetAvailablePermissionsRequest),
  ]);
}